<template>
    <el-dialog v-dialogDrag :title="$t(i18nPage+'表格配置')" width="820px" :close-on-click-modal="false" v-if="componentShow"
               :visible.sync="confTbVis" >
        <div class="dialog-content dialog-content-medium" style="height: 600px;">
            <el-form label-position="top" ref="tbConfgform" :model="tbConfgform">
                <div class="dialog-main">
                    <el-row :gutter=8>
                        <el-col :span=12>
                            <el-form-item :label="$t(i18nPage+'可选格式')" prop="exportUsertmpId">
                                <call-table ref="formCallTable" table-name="bas_table_form" v-model="formId"
                                            :default-extra="tableNo" @change="formChange"></call-table>
                            </el-form-item>
                        </el-col>
                        <el-col :span=8 class="colbutton">
                            <el-button type="primary" @click="saveConfig('save')" :loading="saveLoading"  class="zm-button2">{{$t(i18nPage+'保存')}}</el-button>
                            <el-button type="primary" @click="resaveForm" :loading="resaveLoading" class="zm-button3">{{$t(i18nPage+'另存为')}}</el-button>
                            <!--<el-button type="primary" @click="userTmpExport" :loading="userTmpLoading">通用模版导出</el-button>-->
                        </el-col>
                        <el-col :span=4 class="colbutton">
                            <el-row type="flex" justify="end">
                                <el-button type="danger" @click="delForm"  :loading="delLoading" class="zm-button2">{{$t(i18nPage+'删除')}}</el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-table style="width: 100%" border height="540"
                              :data="tbConfgform.fieldList.filter(data => !search || data.label.toLowerCase().includes(search.toLowerCase()))"
                              highlight-current-row @current-change="handleCurrentChange"
                              stripe class="config-table-cls">
                        <el-table-column type="index" :label="$t(i18nPage+'序号')" width="60" align="center"></el-table-column>
                        <!--<el-table-column type="selection" width="55"></el-table-column>-->
                        <el-table-column property="label" :label="$t(i18nPage+'字段名称')" width="240">
                            <template slot="header" slot-scope="scope">
                                <el-input v-model="search" size="mini" :placeholder="$t(i18nPage+'输入关键字搜索')"/>
                            </template>
                             <template slot-scope="scope">
                                 {{$t(scope.row.label)}}
                             </template>
                        </el-table-column>
                        <!--<el-table-column property="level" label="级数"></el-table-column>
                        <el-table-column property="parentText" label="上级名称"></el-table-column>-->
                        <el-table-column property="isshow" :label="$t(i18nPage+'是否显示')" width="100" align="center" header-align="left">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.isshow" :active-value=1 :inactive-value=0></el-switch>
                                <!--<el-select v-model="scope.row.isshow" placeholder="" filterable >
                                    <el-option v-for="item in isshowList" :key="item.value"
                                               :label="item.label" :value="item.value"></el-option>
                                </el-select>-->
                            </template>
                        </el-table-column>

                        <el-table-column property="sort" :label="$t(i18nPage+'排序')" width="150" header-align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button type=primary @click="sortTable" style="width: 60px">{{$t(i18nPage+'重排')}}</el-button>
                                <el-button type="primary" @click="downRow" style="width: 30px;padding: 6px 0;text-align: center;">↓</el-button>
                                <el-button type="primary" @click="upRow" style="width: 30px;padding: 6px 0;text-align: center;">↑</el-button>
                            </template>
                            <template slot-scope="scope">
                                <num-input v-model="scope.row.sort" :min=1></num-input>
                            </template>
                        </el-table-column>
                        <el-table-column property="width" :label="$t(i18nPage+'列宽')" align="center" header-align="left">
                            <template slot-scope="scope">
                                <num-input v-model="scope.row.width" :min=50 :max=400></num-input>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </el-form>
        </div>
        <template #footer>
            <div style="text-align: left;float: left">
                        <el-button type=primary @click="resetConfig" >{{$t(i18nPage+'顺序重置')}}</el-button>
                    </div>
                    <div style="text-align: left;float: left;color: red;padding-top: 5px;padding-left: 10px;">
                        {{$t(i18nPage+'注意：关于列宽调整，需在主页面上设置好，再做保存')}}
                    </div>
                    <div style="text-align: right">
                        <!--<el-button type=primary @click="sortTable" >重新排列</el-button>-->
                    <el-button type=primary @click="saveConfig('load')" :loading="saveLoading">{{$t(i18nPage+'保存并加载')}}</el-button>
                    <el-button  @click="confTbVis = false" class="zm-button2">{{$t(i18nPage+'取消')}}</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
    export default {
        name: "ZmTableConfig",
        beforeCreate() {
            this.i18nPage = 'component.ZmTableConfig.';
        },
        props: {
            col: {
                type: Array
            },
            tableNo:{
                type:String
            },
            modifyUrl:{
                type:String,
                default:'bas/tableForm/modify'
            },
            addUrl:{
                type:String,
                default:'bas/tableForm/add'
            },
            delUrl:{
                type:String,
                default:'bas/tableForm/del'
            },
            findUrl:{
                type:String,
                default:'bas/tableConfig/find'
            }
        },
        data(){
            return {
                i18nPage: 'component.ZmTableConfig.',
                confTbVis:false,
                // isshowList:[{label:'否',value:0},{label:'是',value:1}],
                tbConfgform:{
                    fieldList:[]
                },
                colMap:{},
                multipleSelection: [],
                componentShow:true,
                search:'',
                formId:'',
                saveLoading:false,
                resaveLoading:false,
                delLoading:false,
                currentRow:null,
                
            }
        },
        computed:{

        },
        beforeDestroy(){
            this.multipleSelection = [];
            this.tbConfgform.fieldList = [];
            this.componentShow = false;
        },
        methods: {
            upRow(){
                let tableData = this.tbConfgform.fieldList;
                if(tableData && tableData.length > 0){
                    if(!this.currentRow){
                        this.$util.show(this.$t(this.i18nPage+"请选择数据"),1);
                        return;
                    }
                    let rowIndex = tableData.indexOf(this.currentRow);
                    if(rowIndex === 0){
                        this.$util.show(this.$t(this.i18nPage+"已经是列表中第一条数据！"),1);
                        return;
                    }
                    let upSort = tableData[rowIndex - 1].sort;
                    let selSort = this.currentRow.sort;
                    this.currentRow.sort = upSort;
                    tableData[rowIndex - 1].sort = selSort;

                    this.tbConfgform.fieldList = this.sortArr(tableData, rowIndex, rowIndex - 1);

                    // this.$refs.detailTable.setTableData(this.sortArr(tableData, rowIndex, rowIndex - 1));
                }else{
                    this.$util.show(this.$t(this.i18nPage+"请选择列"),1);
                }
            },
            downRow(){
                let tableData = this.tbConfgform.fieldList;
                if(tableData && tableData.length > 0){
                    if(!this.currentRow){
                        this.$util.show(this.$t(this.i18nPage+"请选择数据"),1);
                        return;
                    }
                    let rowIndex = tableData.indexOf(this.currentRow);
                    if(rowIndex === (tableData.length - 1)){
                        this.$util.show(this.$t(this.i18nPage+"已经是列表中最后一条数据！"),1);
                        return;
                    }
                    let downSort = tableData[rowIndex + 1].sort;
                    let selSort = this.currentRow.sort;
                    this.currentRow.sort = downSort;
                    tableData[rowIndex + 1].sort = selSort;

                    this.tbConfgform.fieldList = this.sortArr(tableData, rowIndex, rowIndex + 1);
                }else{
                    this.$util.show(this.$t(this.i18nPage+"请选择列"),1);
                }
            },
            sortArr(arr, index1, index2){
                arr[index1] = arr.splice(index2,1,arr[index1])[0]
                return arr
            },
            handleCurrentChange(row){
                this.currentRow = row;
            },
            formChange(row){
                console.log('formChange')
                console.log(row)
                // this.userTmpObj = row;
                if(row && row.id){
                    this.$httpService.get(this.findUrl,{id:row.id}).then(res => {
                        this.loadTableFieldList(res,'change');
                    });
                }else{
                    this.loadTableFieldList([],'change');
                }
            },
            resaveForm(){
                if(this.tbConfgform.fieldList && this.tbConfgform.fieldList.length > 0){
                    let colsconfig = this.getColsconfig();
                    //如果列配置信息不为空则执行回调重新加载表格
                    if(colsconfig && colsconfig.length > 0){
                        let that = this;
                        this.$prompt(this.$t(this.i18nPage+'请输入模版名称'), this.$t(this.i18nPage+'提示'), {
                            confirmButtonText: this.$t(this.i18nPage+'确定'),
                            cancelButtonText: this.$t(this.i18nPage+'取消')
                        }).then(({ value }) => {
                            that.resaveLoading = true;
                            that.$httpService.post(that.addUrl,{
                                formName:value,
                                tableNo:that.tableNo,
                                list:that.tbConfgform.fieldList
                            },{contentType:2}).then(res => {
                                that.resaveLoading = false;
                                that.cleanAndReloadCalltable();
                                that.formId = res;
                                that.$util.show(this.$t(this.i18nPage+'表格配置另存为成功'));
                            }).catch(() => {
                                that.resaveLoading = false;
                                that.$util.show(this.$t(this.i18nPage+'表格配置另存为失败'),2);
                            });
                            // this.$util.show('另存为：'+value);
                        }).catch(() => {
                            this.$util.show(this.$t(this.i18nPage+'取消另存为'));
                        });
                    }else{
                        this.$util.show(this.$t(this.i18nPage+'必须设置显示列'),1);
                        this.saveLoading = false;
                    }
                }else{
                    this.$util.show(this.$t(this.i18nPage+'请设置配置信息'),1);
                    this.saveLoading = false;
                }

            },
            cleanAndReloadCalltable(){
                // this.$util.remove('tf:bas_export_usertmp:'+this.typeNo)
                this.$refs['formCallTable'].getTableList(this.tableNo);
            },
            delForm(){
                if(!this.formId){
                    this.$util.show(this.$t(this.i18nPage+'请选择表格配置'),1);
                    return;
                }
                let that = this;
                this.$util.confirm(this.$t(this.i18nPage+'是否删除此格式'),this.$t(this.i18nPage+'提示')).then(() =>{
                    that.delLoading = true;
                    that.$httpService.post(that.delUrl,{
                        id:this.formId
                    }).then(res => {
                        that.delLoading = false;
                        that.formId = null;
                        that.cleanAndReloadCalltable();
                        that.loadTableFieldList([],'change');
                        that.$util.show(this.$t(this.i18nPage+'格式删除成功'));
                    }).catch(() => {
                        that.delLoading = false;
                        that.$util.show(this.$t(this.i18nPage+'格式删除失败'),2);
                    });
                }).catch(() => {
                    // this.$util.show('取消删除',1);
                })
            },
            openTableConfig(cellws){
                if(this.col && this.col.length > 0 && this.tableNo){
                    // let tempcols = JSON.parse(JSON.stringify(this.col));
                    let userCols = this.$util.get("configTableNo:"+this.tableNo);
                    this.loadTableFieldList(userCols, 'created');
                }
                if(cellws && cellws.length > 0 && this.tbConfgform.fieldList && this.tbConfgform.fieldList.length > 0){
                    for(let i = 0;i < this.tbConfgform.fieldList.length; i++){
                        if(this.tbConfgform.fieldList[i].isshow == 1){
                            for(let j = 0;j < cellws.length;j++ ){
                                if(this.tbConfgform.fieldList[i].level == cellws[j].level && this.tbConfgform.fieldList[i].text == cellws[j].text){
                                    this.$set(this.tbConfgform.fieldList[i],'width',cellws[j].width)
                                    cellws.splice(j,1);
                                    break;
                                }
                            }
                        }
                    }
                }
                this.sortTable();
                this.confTbVis = true;
            },
            saveConfig(type){
                if(!this.formId){
                    if(type && 'load' == type){
                        if(this.tbConfgform.fieldList && this.tbConfgform.fieldList.length > 0){
                            let colsconfig = this.getColsconfig();
                            //如果列配置信息不为空则执行回调重新加载表格
                            if(colsconfig && colsconfig.length > 0){
                                let that = this;
                                this.$prompt(this.$t(this.i18nPage+'请输入模版名称'), this.$t(this.i18nPage+'提示'), {
                                    confirmButtonText: this.$t(this.i18nPage+'确定'),
                                    cancelButtonText: this.$t(this.i18nPage+'取消')
                                }).then(({ value }) => {
                                    that.saveLoading = true;
                                    that.$httpService.post(that.addUrl,{
                                        formName:value,
                                        tableNo:that.tableNo,
                                        list:that.tbConfgform.fieldList
                                    },{contentType:2}).then(res => {
                                        that.saveLoading = false;
                                        that.cleanAndReloadCalltable();
                                        that.formId = res;
                                        that.$util.show(this.$t(this.i18nPage+'表格配置另存为成功'));
                                        that.$util.set("configTableNo:"+this.tableNo,this.tbConfgform.fieldList);
                                        that.$emit('saveconfig',colsconfig);
                                        that.confTbVis = false;
                                    }).catch(() => {
                                        that.saveLoading = false;
                                        that.$util.show(this.$t(this.i18nPage+'表格配置另存为失败'),2);
                                    });
                                    // this.$util.show('另存为：'+value);
                                }).catch(() => {
                                    this.$util.show(this.$t(this.i18nPage+'取消另存为'));
                                });
                            }else{
                                this.$util.show(this.$t(this.i18nPage+'必须设置显示列'),1);
                                this.saveLoading = false;
                            }
                        }else{
                            this.$util.show(this.$t(this.i18nPage+'请设置配置信息'),1);
                            this.saveLoading = false;
                        }
                    }else{
                        this.$util.show(this.$t(this.i18nPage+'请选择格式'), 1);
                        return;
                    }
                }else{
                    if(this.tbConfgform.fieldList && this.tbConfgform.fieldList.length > 0){
                        let colsconfig = this.getColsconfig();
                        //如果列配置信息不为空则执行回调重新加载表格
                        if(colsconfig && colsconfig.length > 0){
                            this.saveLoading = true;
                            this.$httpService.post(this.modifyUrl,{
                                id:this.formId,
                                tableNo:this.tableNo,
                                type: type,
                                list:this.tbConfgform.fieldList},{contentType:2}
                            ).then(res => {
                                this.$util.show(this.$t(this.i18nPage+"表格配置信息保存成功"));
                                this.saveLoading = false;
                                if(type && 'load' == type){
                                    this.$util.set("configTableNo:"+this.tableNo,this.tbConfgform.fieldList);
                                    this.$emit('saveconfig',colsconfig);
                                    this.confTbVis = false;
                                }
                            }).catch(res => {
                                this.$util.show(this.$t(this.i18nPage+"表格配置信息保存失败"));
                                this.saveLoading = false;
                            });
                        }else{
                            this.$util.show(this.$t(this.i18nPage+'必须设置显示列'),1);
                        }
                    }else{
                        this.$util.show(this.$t(this.i18nPage+'请设置配置信息'),1);
                    }
                }

            },
            getColsconfig(){
                let colsconfig = [];
                let level1Cols = [];
                let level2Cols = [];
                let level3Cols = [];
                this.tbConfgform.fieldList.forEach((item,index) =>{
                    switch (item.level){
                        case 1:
                            level1Cols.push(item);
                            break;
                        case 2:
                            level2Cols.push(item);
                            break;
                        case 3:
                            level3Cols.push(item);
                            break;
                    }
                });
                if(level1Cols && level1Cols.length > 0){
                    //一级列排序
                    level1Cols.sort((col1,col2) => {
                        return col1.sort - col2.sort;
                    });
                    //二级列排序
                    if(level2Cols && level2Cols.length > 0){
                        level2Cols.sort((col1,col2) => {
                            return col1.sort - col2.sort;
                        });
                    }
                    //三级列排序
                    if(level3Cols && level3Cols.length > 0){
                        level3Cols.sort((col1,col2) => {
                            return col1.sort - col2.sort;
                        });
                    }

                    //组装一级列
                    level1Cols.forEach((item,index) => {
                        let tempcol = this.colMap[item.text];
                        if(item.width && item.width > 0){
                            tempcol.width = item.width;
                        }
                        //判断列是否显示， 并且判断列信息是否存在， 防止表格列变化加载无效列
                        if(item.isshow === 1 && tempcol){
                            //加入列有下级则组装下级列信息， 否则将列信息加入到配置信息中
                            if(tempcol.children && tempcol.children.length > 0 ){
                                //加入下级列
                                let child1cols = [];
                                level2Cols.forEach((level2col,levle2index) => {
                                    tempcol.children.forEach((child1,child1index) => {
                                        //判断是否是下级二级列并且为显示列
                                        if(level2col.isshow == 1 && level2col.parentText == item.text && level2col.text == child1.text){
                                            if(level2col.width && level2col.width > 0){
                                                child1.width = level2col.width;
                                            }
                                            //判断二级列下面是否有3级列, 没有则之间加载二级列配置信息中
                                            if(child1.children && child1.children.length > 0 ){
                                                let child2cols = [];
                                                level3Cols.forEach((level3col,levle3index) => {
                                                    child1.children.forEach((child2,child2index) => {
                                                        if(level3Cols.isshow == 1 && level3Cols.parentText == child1.text && level3Cols.text == child2.text){
                                                            if(level3col.width && level3col.width > 0){
                                                                child2.width = level3col.width;
                                                            }
                                                            child2cols.push(child2);
                                                        }
                                                    })
                                                });
                                                //判断二级下面是否有3级列信息，没有则二级列作废
                                                if(child2cols.length > 0){
                                                    child1.children = child2cols;
                                                    child1cols.push(child1);
                                                }
                                            }else{
                                                child1cols.push(child1);
                                            }
                                        }
                                    })
                                });
                                //判断一级下面是否有3级列信息，没有则一级列作废
                                if(child1cols.length > 0){
                                    tempcol.children = child1cols
                                    colsconfig.push(tempcol)
                                }
                            }else{
                                colsconfig.push(tempcol);
                            }
                        }
                    });
                }
                return colsconfig;
            },
            sortTable(){
                if(this.tbConfgform.fieldList && this.tbConfgform.fieldList.length > 0){
                    this.tbConfgform.fieldList.sort(function(a, b){
                        if (a.level === b.level) {
                            return a.sort - b.sort;
                        } else {
                            return a.level - b.level;
                        }
                    });


                    let tempList = [];
                    let tempSort = 1;
                    for(let i = 0;i < this.tbConfgform.fieldList.length; i++){
                        if(this.tbConfgform.fieldList[i].level === 1){
                            // let tempSort = lvCount*2 + 1;
                            this.tbConfgform.fieldList[i].sort = tempSort;
                            tempList.push(this.tbConfgform.fieldList[i]);
                            tempSort ++;
                            this.sortChildField(tempList,this.tbConfgform.fieldList[i].text, 2);
                        }
                    }
                    this.tbConfgform.fieldList = tempList;
                }
            },
            sortChildField(tempList,text,level,label){
                let tempSort = 1;
                for(let i = 0;i < this.tbConfgform.fieldList.length; i++){
                    if(this.tbConfgform.fieldList[i].level === level && this.tbConfgform.fieldList[i].parentText === text){
                        // let tempSort = lvCount*2 + 1;
                        this.tbConfgform.fieldList[i].sort = tempSort;
                        tempList.push(this.tbConfgform.fieldList[i]);
                        tempSort ++;
                        this.sortChildField(tempList,this.tbConfgform.fieldList[i].text, (level + 1));
                    }
                }
            },
            resetConfig(){
                if(this.col && this.col.length > 0 && this.tableNo){
                    this.tbConfgform.fieldList = [];
                    //组装列表信息 添加value formatter filter 字段方便复制列转化数据用
                    for(let i = 0;i<this.col.length;i++){
                        let cell = Object.assign({},this.col[i]);
                        // this.colMap[cell.text] = cell;
                        let level1label = cell.text;
                        this.tbConfgform.fieldList.push({
                            text:cell.text,
                            label:level1label,
                            level:1,
                            parentText:'',
                            sort:i+1,
                            isshow:1,
                            value:cell.value || '',
                            formatter:cell.formatter,
                            filter:cell.filter,
                            width:cell.width ? cell.width : null
                        });
                        if(cell.children && cell.children.length > 0){
                            for(let j = 0;j<cell.children.length;j++){
                                let childcell = cell.children[j];
                                let level2label = level1label+'.'+childcell.text;
                                this.tbConfgform.fieldList.push({
                                    text:childcell.text,
                                    label:level2label,
                                    level:2,
                                    parentText:cell.text,
                                    sort:j+1,
                                    isshow:1,
                                    value:childcell.value || '',
                                    formatter:childcell.formatter,
                                    filter:childcell.filter,
                                    width:childcell.width ? childcell.width : null
                                });
                                if(childcell.children && childcell.children.length > 0){
                                    for(let k = 0;k<childcell.children.length;k++){
                                        let child2cell = childcell.children[k];
                                        let level3label = level2label+'.'+child2cell.text;
                                        this.tbConfgform.fieldList.push({
                                            text: child2cell.text,
                                            label: level3label,
                                            level: 3,
                                            parentText: childcell.text,
                                            sort: k + 1,
                                            isshow: 1,
                                            value:child2cell.value || '',
                                            formatter:child2cell.formatter,
                                            filter:child2cell.filter,
                                            width:child2cell.width ? child2cell.width : null
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            },
            loadTableFieldList(userCols,type){
                this.tbConfgform.fieldList = [];
                let level1ColMap = {};
                let level2ColMap = {};
                let level3ColMap = {};
                let flag = false;
                if(userCols && userCols.length > 0) {
                    if('created' == type){
                        // 设置默认格式
                        this.formId = userCols[0].formId;
                    }
                    flag = true;
                    userCols.forEach((item, index) => {
                        switch (item.level) {
                            case 1:
                                level1ColMap[item.text] = item;
                                break;
                            case 2:
                                level2ColMap[item.text+item.parentText] = item;
                                break;
                            case 3:
                                level3ColMap[item.text+item.parentText] = item;
                                break;
                        }
                    });
                }
                for(let i = 0;i<this.col.length;i++){
                    let cell = $.extend(true,{}, this.col[i]);
                    if('created' == type){
                        this.colMap[cell.text] = cell;
                    }
                    let level1col = level1ColMap[cell.text];
                    let level1label = cell.text;
                    if(level1col){
                        this.tbConfgform.fieldList.push(Object.assign({
                            value:cell.value || '',
                            label:level1label,
                            formatter:cell.formatter,
                            filter:cell.filter,
                            width:cell.width ? cell.width : null
                        },level1col));
                    }else{
                        this.tbConfgform.fieldList.push({
                            text:cell.text,
                            label:level1label,
                            level:1,
                            parentText:'',
                            sort:i+1,
                            isshow: flag ? 0 : 1,
                            value:cell.value || '',
                            formatter:cell.formatter,
                            filter:cell.filter,
                            width:cell.width ? cell.width : null
                        });
                    }
                    if(cell.children && cell.children.length > 0){
                        for(let j = 0;j<cell.children.length;j++){
                            let childcell = cell.children[j];
                            let level2col = level2ColMap[childcell.text+cell.text];
                            let level2label = level1label+'.'+childcell.text;
                            if(level2col){
                                this.tbConfgform.fieldList.push(Object.assign({
                                    value:childcell.value || '',
                                    label:level2label,
                                    formatter:childcell.formatter,
                                    filter:childcell.filter,
                                    width:childcell.width ? childcell.width : null
                                },level2col));
                            }else{
                                this.tbConfgform.fieldList.push({
                                    text:childcell.text,
                                    label:level2label,
                                    level:2,
                                    parentText:cell.text,
                                    sort:j+1,
                                    isshow:flag ? 0 : 1,
                                    value:childcell.value || '',
                                    formatter:childcell.formatter,
                                    filter:childcell.filter,
                                    width:childcell.width ? childcell.width : null
                                });
                            }
                            if(childcell.children && childcell.children.length > 0){
                                for(let k = 0;k<childcell.children.length;k++){
                                    let child2cell = childcell.children[k];
                                    let level3col = level3ColMap[child2cell.text+childcell.text];
                                    let level3label = level2label+'.'+child2cell.text;
                                    if(level3col){
                                        this.tbConfgform.fieldList.push(Object.assign({
                                            value:child2cell.value || '',
                                            label:level3label,
                                            formatter:child2cell.formatter,
                                            filter:child2cell.filter,
                                            width:child2cell.width ? child2cell.width : null
                                        },level3col));
                                    }else {
                                        this.tbConfgform.fieldList.push({
                                            text: child2cell.text,
                                            label:level3label,
                                            level: 3,
                                            parentText: childcell.text,
                                            sort: k + 1,
                                            isshow: flag ? 0 : 1,
                                            value:child2cell.value || '',
                                            formatter:child2cell.formatter,
                                            filter:child2cell.filter,
                                            width:child2cell.width ? child2cell.width : null
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
                if(JSON.stringify(level1ColMap) != "{}" ){
                    this.sortTable();
                }
            }
            /*handleSelectionChange(val){
                this.multipleSelection = val;
            },
            copyColContent($event){
                if(this.multipleSelection && this.multipleSelection.length > 0){
                    this.$emit("copyCol",{$event:$event,colFields:this.multipleSelection});
                }else{
                    this.$util.show("请选择需要复制的数据列！",1);
                }
            }*/
        },
        created(){
            if(this.col && this.col.length > 0 && this.tableNo){
                // let tempcols = JSON.parse(JSON.stringify(this.col));
                let userCols = this.$util.get("configTableNo:"+this.tableNo);
                this.loadTableFieldList(userCols, 'created');
            }
        }

    };
</script>
<style>
    .config-table-cls .cell {
        height: 28px !important;
    }
    .config-table-cls th div {
        line-height: 28px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/CommonTable/ZmTableConfig.vue